module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.bb92b8ea.png";